import React, { useEffect, useState } from 'react';
import axiosClient, { getData } from '../global/Globalapi';
import { Link } from 'react-router-dom';

const Demo_2 = ({ selectedCategory }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseURL = axiosClient.defaults.baseURL;

  useEffect(() => {
    console.log("Selected Category in demo 2:", selectedCategory);
  }, [selectedCategory]);

  useEffect(() => {
const fetchImages = async () => {
  if (!selectedCategory?.product_category_id) return;

  setLoading(true);
  try {
    // ✅ FIXED: Remove the nested getData call
    const res = await getData(`/sub_category_images/${selectedCategory.product_category_id}`);

    const seen = new Set();
    const processed = res.data.reduce((acc, img) => {
      if (!seen.has(img.product_category_id)) {
        seen.add(img.product_category_id);
        acc.push({
          url: `${baseURL}/uploads/product_category_image/${img.fileName}`,
          alt: img.category_name || img.description || 'Product image',
          id: img.product_category_id,
          description: img.description || '',
          name: img.category_name || 'Unnamed Product'
        });
      }
      return acc;
    }, []);

    setProducts(processed);
    setError(null);
  } catch (error) {
    console.error("Error loading subcategory images:", error);
    setProducts([]);
    setError("Failed to load products");
  } finally {
    setLoading(false);
  }
};

    fetchImages();
  }, [selectedCategory]);

  if (!selectedCategory) return null;

  if (loading) {
    return (
      <div className="py-12 px-6 md:px-16 bg-gray-50">
        <h2 className="text-3xl font-bold mb-8 text-center">Loading Products...</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {[...Array(4)].map((_, idx) => (
            <div key={idx} className="animate-pulse bg-white rounded-xl overflow-hidden shadow-lg">
              <div className="w-full h-64 bg-gray-200"></div>
              <div className="p-4">
                <div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-full"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6 mt-2"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-12 px-6 md:px-16 bg-gray-50 text-center">
        <h2 className="text-3xl font-bold mb-4">
          {/* ✅ FIXED: Use category_name */}
          {selectedCategory.category_name ?
            `Products under ${selectedCategory.category_name}` :
            'Products'}
        </h2>
        <div className="text-red-500 text-lg">{error}</div>
        <button
          onClick={() => window.location.reload()}
          className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="py-12 px-6 md:px-16 bg-gray-50">
      <h2 className="text-3xl font-bold mb-2 text-center">
        {/* ✅ FIXED: Use category_name */}
        {selectedCategory.category_name ?
          `Featured Product` :
          'Our Products'}
      </h2>
      <p className="text-center text-gray-600 mb-8 max-w-2xl mx-auto">
        {/* ✅ FIXED: Use category_name */}
        {selectedCategory.category_name ?
          `Explore our other Featured Product` :
          'Explore our premium product collection'}
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {products.map((product, idx) => (
          <div
            key={idx}
            className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
          >
            <div className="relative h-64 overflow-hidden">
              <img
                src={product.url}
                alt={product.alt}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.src = '';
                }}
              />
            </div>

            <div className="p-4">
              <h3 className="text-xl font-bold mb-2 text-gray-800">
                {product.name}
              </h3>
              <p className="text-gray-600 mb-4 line-clamp-2">{product.description}</p>
              {/* <Link
                to={`/shopping?product=${product.id}`} */}
                <Link
                   to={`/shopping?product=${btoa(product.id.toString())}`}

                className="inline-block px-4 py-2 text-white rounded-lg transition-colors" 
                style={{
                  backgroundColor: 'var(--button-bg)', 
                  color: 'var(--button-text)'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--button-bg-hover)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--button-bg)'}
              >
                View Product
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Demo_2;